module.exports = __webpack_public_path__ + "img/performance-work-icon5.04d23fa2.png";